export default __webpack_public_path__ + "static/media/triple-spicy.ccec79fa.svg";